import dayjs from 'dayjs'
export const displayDateUnformatted = dayjs().day(-7)
export const startDate = (dayjs().$y - 1).toString() + '-10-02'
export const endDate = dayjs().day(+6).format('YYYY-MM-DD') 
export const displayDate = dayjs().day(-1).format('YYYY-MM-DD')
